// O código de cor da página inteira mora aqui, e é semântico: a cor diz o que a empresa pode fazer
// com o número, nunca só decora. Verde é desfecho bom, âmbar é algo parado que um aviso destrava,
// vermelho é barrado por política — o único que a empresa não resolve sozinha —, `dado` é neutro
// com peso e cinza é neutro sem peso.
//
// `dado`, e não a cor da marca: na Faz Cred os dois são o mesmo azul, mas a marca de um parceiro
// pode encostar numa cor semântica — o rosa da Newbe ao lado do vermelho de "barrado" vira a mesma
// fatia. Cada parceiro escolhe o seu neutro de gráfico em `src/parceiros/`.
//
// O âmbar aqui é o de preenchimento (--color-off-fill), não o --color-off de texto: numa barra ou
// numa fatia o tom escuro de texto encosta no vermelho e as duas deixam de se distinguir.
//
// Tailwind varre o fonte procurando nomes de classe inteiros, então cada classe aparece escrita por
// extenso: montar `bg-${tom}` faria a cor sumir do bundle sem erro nenhum.
export type Tom = "ok" | "off" | "stop" | "dado" | "mute"

export const FUNDO: Record<Tom, string> = {
    ok: "bg-ok",
    off: "bg-off-fill",
    stop: "bg-stop",
    dado: "bg-data",
    mute: "bg-mute",
}

export const TRACO: Record<Tom, string> = {
    ok: "stroke-ok",
    off: "stroke-off-fill",
    stop: "stroke-stop",
    dado: "stroke-data",
    mute: "stroke-mute",
}
